<template>
  <v-row v-if="!loading">
    <bubble-chart
      :chart-data="bubbleData"
      :options="bubbleOptions"
      style="position: relative; width:92%; max-height: 250px; height: 250px;"
    />
  </v-row>
</template>

<script>
import BubbleChart from './BubbleChart.vue'
import { getDuration, roundToTwo } from '../Constants'
import moment from 'moment'

export default {
  props: {
    course: {
      type: Object,
      required: false
    },
    yLabel: {
      type: String,
      required: true
    },
    xLabel: {
      type: String,
      required: true
    },
    agent: {
      type: String,
      required: false,
      default: null
    },
    agentCoursesData: {
      type: Array,
      required: false,
      default: null
    },
    agentName: {
      type: String,
      required: false,
      default: null
    }
  },
  components: {
    BubbleChart
  },
  data() {
    return {
      bubbleOptions: {},
      bubbleData: {},
      leaderboardData: null,
      loading: false
    }
  },
  mounted() {
    this.loading = true
    this.setData()
    this.fillLeaderboard()
    this.loading = false
  },
  methods: {
    setData() {
      this.leaderboardData = new Array({ name: 'time', data: [] })
      if (
        this.agentCoursesData != null &&
        this.agentCoursesData !== undefined
      ) {
        this.agentCoursesData.forEach(element => {
          if (element.timeSpentLeaderBoard != null) {
            element.timeSpentLeaderBoard.forEach(e => {
              let timeEle = _.find(this.leaderboardData[0].data, {
                name: e.name
              })
              if (timeEle != null) {
                timeEle.interactionsCount += e.interactionsCount
                timeEle.timeSpent = moment
                  .duration(timeEle.timeSpent)
                  .add(e.timeSpent)
              } else {
                this.leaderboardData[0].data.push(e)
              }
            })
          }
        })
      } else {
        let leaderboard = new Array({ name: 'time', interactions: [] })

        if (
          this.course.interactions != null &&
          this.course.interactions !== undefined
        ) {
          const sectionData = new Array()
          this.course.interactions.forEach(element => {
            if (element.duration != null && element.duration !== undefined) {
              element.duration = getDuration(element.duration)
            }

            if (
              element.verb !== 'failed' &&
              element.verb !== 'passed' &&
              element.verb !== 'completed'
            ) {
              if (element.duration != null && element.duration !== undefined) {
                leaderboard[0].interactions.push(element)
              }
            }
          })

          this.leaderboardData[0].data = _.chain(leaderboard[0].interactions)
            // Group the elements of Array based on `name` property
            .groupBy('name')
            // `key` is group's name (name), `value` is the array of interactions
            .map((value, key) => ({ name: key, interactions: value }))
            .value()
        }
      }
    },
    fillLeaderboard() {
      let bubble = new Array()
      let maxTime = null
      let maxInt = 0
      let minInt = 10000
      let bgColor = this.agent == null ? 'rgba(255,255,255,0.2)' : new Array()
      const leaderboard = this.leaderboardData[0]

      leaderboard.data.forEach(element => {
        let intCount = 0
        let timeSpent = null

        if (
          this.agentCoursesData != null &&
          this.agentCoursesData !== undefined
        ) {
          bgColor.push(
            element.name === this.agentName
              ? '#E37225'
              : 'rgba(255,255,255,0.2)'
          )

          intCount = element.interactionsCount
          if (element.interactionsCount > maxInt) {
            maxInt = element.interactionsCount
          }

          if (element.interactionsCount < minInt) {
            minInt = element.interactionsCount
          }

          if (timeSpent == null) {
            timeSpent = moment.duration(element.timeSpent)
          } else {
            timeSpent = moment.duration(element.timeSpent).add(timeSpent)
          }
          if (maxTime == null) {
            maxTime = timeSpent
          } else if (
            moment.duration(timeSpent).asSeconds() >
            moment.duration(maxTime).asSeconds()
          ) {
            maxTime = timeSpent
          }
        } else {
          if (this.agent != null) {
            bgColor.push(
              element.userId === parseInt(this.agent)
                ? '#E37225'
                : 'rgba(255,255,255,0.2)'
            )
          }

          if (element.interactions.length > maxInt) {
            maxInt = element.interactions.length
          }

          if (element.interactions.length < minInt) {
            minInt = element.interactions.length
          }

          element.interactions.forEach(ele => {
            if (ele.score == null && ele.score === undefined) {
              intCount++
              if (timeSpent == null) {
                timeSpent = moment.duration(ele.duration)
              } else {
                timeSpent = moment.duration(ele.duration).add(timeSpent)
              }
              if (maxTime == null) {
                maxTime = timeSpent
              } else if (
                moment.duration(timeSpent).asSeconds() >
                moment.duration(maxTime).asSeconds()
              ) {
                maxTime = timeSpent
              }
            }
          })
        }
        bubble.push({ x: intCount, y: getDuration(timeSpent), r: 15 })
      })
      maxTime = moment.duration(maxTime).add(2, 'minutes')
      let minTime = moment.duration(maxTime).subtract(maxTime)
      this.bubbleData = {
        datasets: [
          {
            metadata: leaderboard.data,
            backgroundColor: bgColor,
            borderColor: '#E37225',
            data: bubble
          }
        ]
      }

      this.bubbleOptions = {
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              return data['labels'][tooltipItem[0]['index']]
            },
            label: function(tooltipItem, data) {
              const leaderData =
                data['datasets'][0]['metadata'][tooltipItem['index']]
              let toolTip = new Array()
              if (leaderData !== undefined && leaderData != null) {
                toolTip.push(leaderData.name)
                let intCount = 0
                let timeSpent = null
                leaderData.interactions.forEach(element => {
                  if (element.score == null || element.score === undefined) {
                    intCount++
                    if (
                      element.duration !== undefined &&
                      element.duration != null
                    ) {
                      if (timeSpent == null) {
                        timeSpent = moment.duration(element.duration)
                      } else {
                        timeSpent = moment
                          .duration(element.duration)
                          .add(timeSpent)
                      }
                    }
                  }
                })
                toolTip.push(`Interactions: ${intCount}`)
                toolTip.push(`Time Spent: ${getDuration(timeSpent)}`)
              }
              return toolTip
            }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000'
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              type: 'time',
              autoSkip: true,
              distribution: 'series',
              time: {
                unit: 'second',
                parser: 'H:mm:ss',
                displayFormats: {
                  second: 'H:mm:ss'
                },
                unitStepSize: 30
              },
              ticks: {
                max: getDuration(maxTime),
                min: getDuration(minTime)
              },
              scaleLabel: {
                display: true,
                labelString: this.yLabel
              }
            }
          ],
          xAxes: [
            {
              distribution: 'series',
              scaleLabel: {
                display: true,
                labelString: this.xLabel
              },
              ticks: {
                max: maxInt,
                min: minInt
              }
            }
          ]
        }
      }
    }
  }
}
</script>

<style>
.bubble-chart {
  max-height: 250px;
  height: 250px;
  width: 90%;
  position: relative;
}
</style>
